import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch {}
    setLoading(false);
    setSent(true);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="forgot-page">
      {sent ? (
        <div className="text-center">
          <MailCheck className="h-12 w-12 text-brand mx-auto" />
          <h1 className="font-display text-2xl font-extrabold uppercase tracking-tight mt-5">Check your inbox</h1>
          <p className="text-sm text-zinc-400 mt-3">If that email is registered, a reset link has been sent. It expires in 1 hour.</p>
          <Link to="/login" data-testid="back-to-signin" className="inline-block mt-8 font-mono text-xs uppercase tracking-widest text-brand hover:underline">← Back to sign in</Link>
        </div>
      ) : (
        <>
          <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight text-center">Reset Password</h1>
          <p className="text-center text-sm text-zinc-400 mt-2">Enter your email and we'll send a reset link.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div><Label className="text-xs">Email</Label><Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-zinc-900 border-zinc-800 mt-1.5" /></div>
            <button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full rounded-full bg-brand text-black py-3 text-sm font-bold uppercase tracking-wide hover:bg-brand-hover active:scale-95 transition disabled:opacity-60 flex items-center justify-center gap-2">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send Reset Link"}
            </button>
          </form>
          <p className="text-center mt-8"><Link to="/login" data-testid="back-to-signin" className="font-mono text-xs uppercase tracking-widest text-zinc-500 hover:text-brand">← Back to sign in</Link></p>
        </>
      )}
    </div>
  );
}
